import React from 'react'

import { HealthAndSafetyRounded } from '@mui/icons-material'
import './badge.css'

const Badge = ({title, text}: any) => {

  return (
    <>
        <div className='badge-wrapper'>
            <div className="badge-container">
                <span className="badge-header">
                    <HealthAndSafetyRounded />
                    {title}
                </span>
                <span className="badge-dot">•</span>
                <a href="#" className="badge-link">
                    {text}
                </a>
            </div>
        </div>
    </>
  )
}

export default Badge